<template>
  <div v-if="dataIsLoad" class="slide-main-block">
    <Carousel
      ref="carouselRef"
      class="recommend-slide"
      :items-to-show="1"
      :breakpoints="breakpoints"
    >
      <Slide v-for="item in selectedProductImg" :key="item.CustomMarketID">
        <div class="item-box">
          <div class="inner">
            <div class="item-img-box">
              <i v-if="item.VideoUrl" class="icon-play" @click="zoomPic(index, $event)" />
              <NewImage :url="item.Url" :size="''" :name="itemDatas.Name" />
            </div>
          </div>
        </div>
      </Slide>
    </Carousel>

    <ul class="product-photo-page">
      <li
        v-for="(item, index) in selectedProductImg"
        :key="index"
        :class="{ 'slick-active': current == index }"
        @click="slideTo(index)"
      >
        <button>
          {{ index + 1 }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';

import { Carousel, Slide } from 'vue3-carousel';

import NewImage from '@global/components/common/Image/NewImage.vue';

import useSetEnv from '@global/composable/useSetEnv';
import useImage from '@global/composable/useImage';
import useZoomBox from '@global/composable/shop/useZoomBox';
import useShopContentStore from '@global/stores/useShopContentStore';

const { setEnv } = useSetEnv();
const { imgTransfer } = useImage();
const shopContentStore = useShopContentStore();
const { pattern } = shopContentStore;
const { dataIsLoad, selectedData, selectedFoodSpec, itemDatas } = storeToRefs(shopContentStore);

const breakpoints = ref({
  600: {
    itemsToShow: 1,
    snapAlign: 'start',
  },
});
const carouselRef = ref();
const current = ref(0);

const isMobile = setEnv.myEquipment();

const selectedProductImg = computed(() => {
  var images = [];

  if (pattern === 1) {
    selectedData.value.Images.forEach((element) => {
      if (element.Category === 0 && images.length < 5) images.push(element);
    });
  } else {
    selectedFoodSpec.value.Product.Images.forEach((element) => {
      if (element.Category === 0 && images.length < 5) {
        images.push(element);
      }
    });
  }

  return images;
});

function slideTo(index) {
  carouselRef.value.slideTo(index);
  current.value = index;
}

function zoomPic(index, event) {
  const datas = [];

  if (pattern === 1) {
    selectedData.value.Images.forEach(function (element) {
      if (element.Category === 0) datas.push(element);
    });
  } else {
    selectedFoodSpec.value.Product.Images.forEach(function (element) {
      if (element.Category === 0) datas.push(element);
    });
  }
  const newData = datas.map((ele) => {
    if (ele.VideoUrl.length !== 0 || ele.VideoMUrl.length !== 0) {
      // 有影片
      return isMobile
        ? imgTransfer(ele.VideoMUrl.length !== 0 ? ele.VideoMUrl : ele.Url, '')
        : imgTransfer(ele.VideoUrl.length !== 0 ? ele.VideoUrl : ele.Url, '');
    } else {
      return imgTransfer(ele.Url, '');
    }
  });

  useZoomBox({
    images: JSON.parse(JSON.stringify(newData)),
    index,
    yPos: event.pageY - window.scrollY,
    tilting: true,
  });
}
</script>
